import { getPrestTotalPrice } from "@/logic/pricesAndDiscount"

export default {
	totals: (state, getters) => {
		const selectedPrestations = getters.selectedPrestations

		const participants = state.participants

		let totalPrice = 0
		let crossedPrice = 0
		selectedPrestations.forEach((prestObj) => {
			const quantity = prestObj.quantity
			totalPrice += quantity * getPrestTotalPrice(prestObj.prestation)
			crossedPrice += prestObj.quantity * prestObj.prestation.crossedPrice
		})

		let maxPromo = parseInt((1 - totalPrice / crossedPrice) * 100)

		let perPrice = totalPrice / participants.length

		const obj = {}

		obj["totalPrice"] = totalPrice
		obj["perPrice"] = perPrice
		if (maxPromo >= 5) obj["crossedPrice"] = crossedPrice
		if (maxPromo >= 5) obj["maxPromo"] = maxPromo

		return obj
	},
}
